import { render, staticRenderFns } from "./SessionTimeoutWarning.vue?vue&type=template&id=c73c8482"
import script from "./SessionTimeoutWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionTimeoutWarning.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports